import { Anchor, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { TestFormats } from "../Stepper/types";
import classes from "./NonAttemptedTestsPlaceholder.module.css";
import NonAttemptedTestsModal from "./NonAttemptedTestsModal";

export default function NonAttemptedTestsPlaceholder({}: {}) {
  const [
    customTestsOpened,
    { open: openCustomTests, close: closeCustomTests },
  ] = useDisclosure(false);
  const [mockExamsOpened, { open: openMockExams, close: closeMockExams }] =
    useDisclosure(false);
  return (
    <Text>
      Here you will find{" "}
      <Anchor
        component={"button"}
        className={classes.link}
        onClick={openCustomTests}
      >
        custom tests
      </Anchor>{" "}
      or{" "}
      <Anchor
        component={"button"}
        className={classes.link}
        onClick={openMockExams}
      >
        mock exams
      </Anchor>{" "}
      you have created, but not taken.
      <NonAttemptedTestsModal
        testFormat={TestFormats.custom}
        opened={customTestsOpened}
        onClose={closeCustomTests}
      />
      <NonAttemptedTestsModal
        testFormat={TestFormats.mockExam}
        opened={mockExamsOpened}
        onClose={closeMockExams}
      />
    </Text>
  );
}
